module.exports = __webpack_public_path__ + "3d103df266e8a2ba9c9a9b6d20cd4fde.jpg";